import { useCallback, useState } from 'react';

export const useCallbackRefState = <T>(defaultValue?: T) => {
    const [refValue, setRefValue] = useState<T | null>(defaultValue ?? null);
    const refCallback = useCallback((value: T | null) => setRefValue(value), []);
    return [refValue, refCallback] as const;
};
